import React from 'react';
import { makeStyles } from '@mui/styles';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import GridWithText from '../@common/GridWithText';
import { WorksheetBaseProps } from '../@types';
import { LwtCopyrightDoubleLines } from '../@common/LwtCopyright';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

type NameTracingProps = WorksheetBaseProps & {
  value: string;
  isCursive?: boolean;
  isNarrow?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
};

const NameTracing = ({ onChange, isCursive, isNarrow, valueMap, printRef }: NameTracingProps) => {
  const classes = useStyles({});

  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  return (
    <PortraitPaperLayout isNarrow={isNarrow} printRef={printRef}>
      <GridWithText
        width={isCursive ? 650 : 600}
        height={100}
        numOfCols={1}
        numOfRows={1}
        handleChange={handleChange}
        valueMap={valueMap}
        spaceBtwnCols={8}
        textLinePaddingTop={40}
        isCursive={isCursive}
        isNarrow={isNarrow}
        containerPaddingTop={40}
        placeholder={t('name')}
        alignItemsLeft
        color="#D5D6D6"
        printGray
      />
      <LwtCopyrightDoubleLines
        containerStyle={{
          position: 'absolute',
          top: '410px',
          left: '30px',
          display: 'flex',
          height: 100,
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }}
      />
      <div
        className={classes.cutLine}
        style={{
          padding: '30px 0 30px'
        }}
      />
      <GridWithText
        width={isCursive ? 650 : 600}
        height={100}
        numOfCols={1}
        numOfRows={1}
        handleChange={handleChange}
        valueMap={valueMap}
        spaceBtwnCols={8}
        textLinePaddingTop={40}
        isCursive={isCursive}
        isNarrow={isNarrow}
        placeholder={t('name')}
        containerPaddingTop={60}
        alignItemsLeft
        inputOffset={1}
        color="#D5D6D6"
        printGray
      />
    </PortraitPaperLayout>
  );
};

const useStyles = makeStyles(() => ({
  cutLine: {
    width: '850px',
    margin: 'auto auto',
    backgroundImage: "url('http://i.stack.imgur.com/cXciH.png')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'relative',
      top: '50%',
      display: 'block',
      borderTop: '3px dashed gray',
      marginTop: '-3px',
      marginRight: 35
    }
  }
}));

export default NameTracing;
